<template>
	<v-container fluid class="pa-0">
		<!-- normal toolbar -->
		<v-row class="grid-toolbar pb-0 d-flex" no-gutters>
			<v-col
				cols="2"
				class="flex-grow-0 flex-shrink-0 d-flex align-center"
			>
				<v-menu :close-on-content-click="false">
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							label="Date Range"
							clearable
							v-bind="attrs"
							v-on="on"
							readonly
							dense
							class="ml-2 mt-0"
							hide-details="true"
							v-model="dates"
							append-icon="mdi-calendar"
						/>
					</template>
					<v-date-picker
						range
						no-title
						color="green"
						v-model="dates"
					/>
				</v-menu>
			</v-col>
			<v-col class="flex-grow-1 flex-shrink-1">
				<quick-filter
					:Columns="visibleColumns"
					:filter="quickFilter"
					@filterChanged="onQuickFilterChanged"
				/>
			</v-col>
			<v-col class="flex-grow-0 flex-shrink-0 d-none d-lg-flex align-end">
				<v-badge
					:value="advancedFilter.Filters.length > 0"
					left
					class="d-none d-lg-flex"
					bordered
					overlap
				>
					<template v-slot:badge>
						<span style="color: white">{{
							advancedFilter.Filters.length
						}}</span>
					</template>
					<v-btn color="primary" @click="onShowAdvancedFilter">
						<v-icon class="mr-1">mdi-magnify</v-icon>
						Advanced search
					</v-btn>
				</v-badge>
			</v-col>
			<v-col class="flex-grow-0 flex-shrink-0 d-none d-lg-flex align-end">
				<!-- Desktop Export Modal (≥lg) -->
				<export-modal
					:timezone-options="true"
					:execution-options="false"
					:data-scope-options="true"
					@export="onExportModalEvent"
				>
					<template #activator="{ on, attrs }">
						<v-btn
							v-bind="attrs"
							v-on="on"
							color="primary"
							class="ml-2"
						>
							<v-icon class="mr-1">mdi-cloud-download</v-icon>
							Export
						</v-btn>
					</template>
				</export-modal>
			</v-col>
			<v-col class="flex-grow-0 flex-shrink-0 d-flex d-lg-none align-end">
				<!-- Mobile/Tablet Dots Menu (<lg) -->
				<v-menu
					v-model="dotsMenuOpen"
					offset-y
					:close-on-content-click="false"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							v-bind="attrs"
							v-on="on"
							class="d-lg-none"
							color="primary"
						>
							<v-icon>mdi-dots-vertical</v-icon>
						</v-btn>
					</template>
					<v-list class="d-lg-none">
						<v-list-item @click="onAdvancedSearchFromDots">
							<v-list-item-content>
								<v-list-item-title>
									<v-icon small left>mdi-magnify</v-icon>
									Advanced search
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<export-modal
							:timezone-options="true"
							:execution-options="false"
							:data-scope-options="true"
							@export="onExportModalEventFromDots"
						>
							<template #activator="{ on, attrs }">
								<v-list-item v-bind="attrs" v-on="on">
									<v-list-item-content>
										<v-list-item-title>
											<v-icon small left
												>mdi-cloud-download</v-icon
											>
											Export
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</template>
						</export-modal>
					</v-list>
				</v-menu>
			</v-col>
		</v-row>
		<v-row v-if="showUsers" class="grid-toolbar pb-0 d-flex" no-gutters>
			<v-col class="flex-grow-1 flex-shrink-1">
				<v-autocomplete
					class="ml-2"
					dense
					small-chips
					deletable-chips
					clearable
					label="Users"
					:items="allUsers"
					item-text="Name"
					item-value="Id"
					multiple
					v-model="selectedUsers"
				>
				</v-autocomplete>
			</v-col>
		</v-row>
		<!-- normal toolbar -->
		<filters-dialog
			v-if="showAdvancedFilter"
			:dialog="showAdvancedFilter"
			:filter="advancedFilter"
			:columns="visibleColumns"
			@filterChanged="onAdvancedFilterChanged"
		/>
	</v-container>
</template>

<script>
import QuickFilter from '../../shared/gridViews/QuickFilter.vue';
import FiltersDialog from '../../shared/gridViews/FiltersDialog';
import ExportModal from '../../shared/export/ExportModal.vue';
import dataService from '../../../services/data/projectGridsService';
import { GeneralActions } from '../../../store/actions';
export default {
	name: 'GridHistoryToolbar',
	components: {
		QuickFilter,
		FiltersDialog,
		ExportModal,
	},
	props: {
		showUsers: Boolean,
		visibleColumns: Array,
		quickFilter: Object,
		advancedFilter: Object,
	},
	data() {
		return {
			dates: [],
			allUsers: [],
			selectedUsers: [],
			showAdvancedFilter: false,
			dotsMenuOpen: false,
		};
	},
	watch: {
		dates(newVal) {
			if (newVal && newVal.length == 2) this.onDateChaged(newVal);
		},
		selectedUsers(newVal) {
			this.onUsersChanged(newVal);
		},
	},
	computed: {
		dateRangeText() {
			return this.dates.join(' ~ ');
		},
	},
	mounted() {
		if (this.showUsers) {
			this.loadUsers();
		}
	},
	methods: {
		onExportModalEvent(exportConfig) {
			this.$emit('export', {
				allData: exportConfig.allData,
				rawData: true,
				timeZone: exportConfig.timeZone,
			});
		},
		onAdvancedSearchFromDots() {
			this.dotsMenuOpen = false;
			this.showAdvancedFilter = true;
		},
		onExportModalEventFromDots(exportConfig) {
			this.dotsMenuOpen = false;
			this.onExportModalEvent(exportConfig);
		},
		onQuickFilterChanged(value) {
			this.$emit('quickFilterChanged', value);
		},
		onAdvancedFilterChanged(value) {
			this.$emit('advancedFilterChanged', value);
			this.showAdvancedFilter = false;
		},
		onDateChaged(value) {
			this.$emit('dateChanged', value);
		},
		onUsersChanged(value) {
			this.$emit('userChanged', value);
		},
		openAdvancedSearch() {
			this.showAdvancedFilter = true;
		},
		loadUsers() {
			this.$store.dispatch(GeneralActions.LOADING, true);
			dataService
				.loadUsers(this.search)
				.then((response) => {
					this.allUsers = response.data.map((x) => ({
						Id: x.Id,
						Name: x.FirstName + ', ' + x.LastName,
					}));
				})
				.catch((error) => {
					this.$store.dispatch(GeneralActions.ERROR, error);
				})
				.finally(() => {
					this.$store.dispatch(GeneralActions.LOADING, false);
				});
		},
		onShowAdvancedFilter() {
			this.showAdvancedFilter = true;
		},
	},
};
</script>

<style lang="scss">
.grid-toolbar-menu .v-list-group {
	border-top: 1px solid #eee;
	border-bottom: 1px solid #eee;

	.v-list-item__title {
		font-size: 14px;
	}
}
</style>
<style>
.v-select.v-input--dense .v-chip {
	margin: 4px;
}
@media only screen and (max-width: 600px) {
	.searchbar-toggle.v-btn.v-btn--text.theme--light.v-size--default {
		min-width: 0px;
		padding: 10px !important;
	}
}
</style>
